export const MemberRoles = {
  COMPANY_OWNER: 'Company Owner',
  COMPANY_ADMIN: 'Company Admin',
  INDEPENDENT_MEMBER: 'Independent Member',
} as const;

export type MemberRole = (typeof MemberRoles)[keyof typeof MemberRoles];
